export const fileToBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (): void => resolve(reader.result as string);
  reader.onerror = (error): void => reject(error);
});

// Utility function to convert base64 to File
export const base64ToFile = (base64: string, filename: string): File => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[ 1 ]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[ n ] = bstr.charCodeAt(n);
  }

  return new File([ u8arr ], filename, { type: mime });
};
